import { RefreshOutlined } from '@mui/icons-material';
import { Button, Stack } from '@mui/material';
import { useSearchQueryContexts } from 'components/search/search.hooks';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

type SearchToolbarButtonsPropsType = {
  buttons?: React.ReactNode;
  showRefresh?: boolean;
  onRefreshClick?: () => void;
};

const SearchToolbarButtons = ({
  buttons,
  showRefresh,
  onRefreshClick,
}: SearchToolbarButtonsPropsType) => {
  const { t } = useTranslation();
  const queries = useSearchQueryContexts();

  const handleRefreshClick = useCallback(() => {
    Object.values(queries).forEach(query => {
      query?.queryState?.refetch();
    });
    if (onRefreshClick) {
      onRefreshClick();
    }
  }, [onRefreshClick, queries]);

  return (
    <Stack direction="row" spacing={1} data-testid="SearchToolbar.Buttons">
      {buttons}
      {showRefresh && (
        <Button
          onClick={handleRefreshClick}
          variant="text"
          data-testid="SearchDataGrid.Button.Refresh"
          startIcon={<RefreshOutlined />}
        >
          {t('SearchDataGrid.refreshButton.label')}
        </Button>
      )}
    </Stack>
  );
};

export default SearchToolbarButtons;
